// extracted by mini-css-extract-plugin
export default {"locales-container":"Locales_locales-container__1cmhT"};